<template>
    <v-btn @click="copy" color="primary" small>
        <v-icon left>mdi-content-copy</v-icon>
        copy
    </v-btn>
</template>

<script>
export default {
    props: {
        questions: {
            type: Array,
        }
    },

    methods: {
        copy() {
            navigator.clipboard.writeText(
                this.questions.map(question => question.id)
                    .join(',')
            )
        }
    }
}
</script>
